import { ppe } from './config.ppe';
import { prd } from './config.prd';
import { dev } from './config.dev';
import { local } from './config.local';

/** This is exported as a const object for convenient selection by consumers */
export const configList = { ppe, prd, dev, local };
